import React from "react";

export function HomePage() {
	return (
    <h1>dddd</h1>
  );
}
